"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportButtonGroup = ReportButtonGroup;
var react_1 = __importStar(require("react"));
var row_ctx_1 = require("../contexts/row_ctx");
var api_1 = require("../api");
var modal_1 = require("../modal");
var confirm_1 = require("./confirm");
function ReportGenButton() {
    var _a = (0, react_1.useContext)(row_ctx_1.RowContext), localRecord = _a.localRecord, updateRecord = _a.updateRecord;
    if (localRecord.report_id) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    function handleClick() {
        (0, api_1.makeReport)(localRecord.order_id).then(function (report_id) {
            updateRecord({ report_id: report_id });
        });
    }
    return (react_1.default.createElement("button", { className: "zmsk-button", onClick: handleClick }, "\u751F\u6210\u62A5\u544A"));
}
function ReportDownloadButtons() {
    var _a = (0, react_1.useContext)(row_ctx_1.RowContext), localRecord = _a.localRecord, updateRecord = _a.updateRecord;
    if (!localRecord.report_id) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var previewUrl = "/xdh1-api/report/download?report_id=".concat(localRecord.report_id);
    var downloadUrl = "/xdh1-api/report/download?report_id=".concat(localRecord.report_id, "&dispos=attachment");
    var commonProps = {
        target: "_blank",
        className: "report-download-button",
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", __assign({ href: previewUrl }, commonProps),
            react_1.default.createElement("button", { className: "zmsk-button" }, "\u67E5\u770B\u62A5\u544A")),
        react_1.default.createElement("a", __assign({ href: downloadUrl }, commonProps),
            react_1.default.createElement("button", { className: "zmsk-button" }, "\u4E0B\u8F7D\u62A5\u544A")),
        react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u4E0A\u4F20\u62A5\u544A" },
            react_1.default.createElement(confirm_1.ConfirmUploadModal, null))));
}
function ReportButtonGroup() {
    return (react_1.default.createElement("span", null,
        react_1.default.createElement(ReportGenButton, null),
        react_1.default.createElement(ReportDownloadButtons, null)));
}
